import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import StudentName from 'components/fragments/StudentName/StudentName';
const StudentNameComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/StudentName/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <StudentName {...props} />
  </ImagesProvider>
);

export default StudentNameComponent;
